export default __webpack_public_path__ + "static/media/R_Rugs.1e7b3869.jpg";